import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-step-buttons',
  templateUrl: './step-buttons.component.html',
  styleUrls: ['./step-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StepButtonsComponent {
  @Input() showPrevious = true;
  @Input() showSave = false;
  @Input() stepper: MatStepper;
  @Output() submit = new EventEmitter();

  goBack(): void {
    this.stepper.previous();
  }

  goForward(): void {
    this.stepper.next();
  }

  onSubmit(): void {
    this.submit.emit(true);
  }

}
